// Google Text-to-Speech 테스트 서비스
// Web Speech API를 사용하여 브라우저에서 직접 테스트

class TTSTestService {
  constructor() {
    this.isSupported = 'speechSynthesis' in window;
    this.voices = [];
    this.selectedVoice = null;
    
    if (this.isSupported) {
      this.loadVoices();
      // 음성 로딩이 완료될 때까지 기다리기
      if (speechSynthesis.onvoiceschanged !== undefined) {
        speechSynthesis.onvoiceschanged = () => this.loadVoices();
      }
    }
  }

  // 사용 가능한 음성 로드
  loadVoices() {
    this.voices = speechSynthesis.getVoices();
    // 한국어 음성 우선 선택
    this.selectedVoice = this.voices.find(voice => 
      voice.lang.startsWith('ko') || voice.lang.includes('Korean')
    ) || this.voices[0];
    


  }

  // 텍스트를 음성으로 변환
  speak(text, options = {}) {
    if (!this.isSupported) {
      console.error('음성 합성을 지원하지 않는 브라우저입니다.');
      return Promise.reject('TTS not supported');
    }

    // 기존 음성 중지
    speechSynthesis.cancel();

    return new Promise((resolve, reject) => {
      const utterance = new SpeechSynthesisUtterance(text);
      
      // 음성 설정
      utterance.voice = this.selectedVoice;
      utterance.rate = options.rate || 0.9; // 조금 느리게
      utterance.pitch = options.pitch || 1.0;
      utterance.volume = options.volume || 1.0;
      utterance.lang = options.lang || 'ko-KR';

      // 이벤트 핸들러
      utterance.onend = () => {

        resolve();
      };

      utterance.onerror = (event) => {
        console.error('음성 재생 실패:', event);
        reject(event);
      };

      utterance.onstart = () => {

      };

      // 음성 재생 시작
      speechSynthesis.speak(utterance);
    });
  }

  // 음성 재생 중지
  stop() {
    if (this.isSupported) {
      speechSynthesis.cancel();
    }
  }

  // 음성 일시정지
  pause() {
    if (this.isSupported) {
      speechSynthesis.pause();
    }
  }

  // 음성 재개
  resume() {
    if (this.isSupported) {
      speechSynthesis.resume();
    }
  }

  // 사용 가능한 한국어 음성 목록 반환
  getKoreanVoices() {
    return this.voices.filter(voice => 
      voice.lang.startsWith('ko') || voice.lang.includes('Korean')
    );
  }

  // 음성 변경
  setVoice(voiceIndex) {
    const koreanVoices = this.getKoreanVoices();
    if (koreanVoices[voiceIndex]) {
      this.selectedVoice = koreanVoices[voiceIndex];

    }
  }

  // 팟캐스트 스크립트 청크 단위로 재생
  async speakPodcastScript(script, onChunkStart = null, onChunkEnd = null) {
    // 스크립트를 문단 단위로 분할
    const chunks = script.split('\n\n').filter(chunk => chunk.trim().length > 0);
    
    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i].trim();
      
      if (onChunkStart) onChunkStart(i, chunk);
      
      try {
        await this.speak(chunk, { rate: 0.85 }); // 팟캐스트용으로 조금 더 느리게
        
        if (onChunkEnd) onChunkEnd(i, chunk);
        
        // 청크 사이에 짧은 휴식
        await new Promise(resolve => setTimeout(resolve, 500));
        
      } catch (error) {
        console.error(`청크 ${i} 재생 실패:`, error);
        break;
      }
    }
  }
}

// 싱글톤 인스턴스
const ttsTestService = new TTSTestService();

export default ttsTestService;